module.exports = __webpack_public_path__ + "static/acupun_2_lg-57c19ad01d1a1f632a2acd56166f8ef0.webp";